const accountDetails = {
  accountDetails: {
    managePreferences: 'Voorkeuren wijzigen',
    email: 'E-mail',
    emailChangeText: 'U moet de e-mailwijziging nog bevestigen',
    confirmationText: 'We hebben een bevestigingsmail verzonden naar %{email}. U moet op de koppeling in die e-mail klikken voordat de e-mailwijziging wordt verwerkt.',
    resendConfirmationEmail: 'Bevestigingsmail opnieuw versturen',
    cancelChange: 'Deze wijziging annuleren',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    phone: 'Telefoon',
    company: 'Bedrijfsnaam',
    saveDetails: 'Accountgegevens opslaan',
    changeEmailRequest: 'Verander e-mail',
    job_profile: {
      label: "Selecteer het functieprofiel van de persoon in het bedrijf",
      tooltip_msg: "Selecteer het primaire functieprofiel van de persoon. Als de gebruiker meer dan één primaire rol heeft, selecteer dan 'Anderen'"
    }
  },
  resetPassword: {
    instructions: 'Uw wachtwoord moet minstens zes tekens lang zijn, minstens één cijfer of speciaal teken bevatten en mag niet hetzelfde zijn als uw e-mailadres.',
    currentPassword: 'Huidig wachtwoord',
    newPassword: 'Nieuw wachtwoord invoeren',
    confirmNewPassword: 'Nieuw wachtwoord bevestigen',
  }
};

export default accountDetails;